// Fragment shader

precision highp float;

uniform float time;
uniform float progress;
uniform sampler2D texture1;
uniform vec4 resolution;
uniform samplerCube uPerlin;

uniform vec3 uColors[3];

varying vec2 vUv;
varying vec3 vLayer0;
varying vec3 vLayer1;
varying vec3 vLayer2;

float PI = 3.141592653589793238;

vec3 brightnessToColor(float b) {
    b = clamp(b / 5.0, 0.0, 1.0);

    vec3 color1   = uColors[0];
    vec3 color2  = uColors[1];
    vec3 color3 = uColors[2];

    if(b < 0.5) {
        float t = smoothstep(0.0, 0.5, b);
        return mix(color1, color2, t);
    } else {
        float t = smoothstep(0.5, 1.0, b);
        return mix(color2, color3, t);
    }
}

float supersun(){
    float sum = 0.0;
    sum += textureCube(uPerlin, vLayer0).r;
    sum += textureCube(uPerlin, vLayer1).r;
    sum += textureCube(uPerlin, vLayer2).r;
    return sum * 0.33;
}

void main() {
    float brightness = supersun();
    brightness = brightness * 8.0 + 1.5;
    vec3 col = brightnessToColor(brightness);
    gl_FragColor = vec4(col, 1.0);
}
